<template>
  <div class="myincome">
    <toptitle :title1="titlework" />
    <section v-for="(item, index) in salaryList"
             :key="index">
      <div @click="gotoIncomeDetail(item)">
        <div class="income-top">
          <p>{{ item.DESCR}}</p>
          <p class="detail">查看明细
            <van-icon name="arrow" />
          </p>
        </div>
        <div>
          实发工资(元)
          <span>{{ item.PAY }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import toptitle from '../components/toptitle'
import dateformat from '@/utils/dateformat'
import { GetMyIncomeDataApi } from '../request/api'

export default {
  name: 'Myincome',
  data() {
    return {
      titlework: '我的薪酬',
      dateSearch: '',
      pwd: '',
      columns: [],
      salaryList: [],
    }
  },
  mounted() {
    this.changeoption()
  },
  methods: {
    gotoIncomeDetail(item) {
      this.$router.push({
        path: '/incomedetail',
        query: { param: JSON.stringify(item) },
      })
    },

    //更改年份
    changeoption(val) {
      if (this.pwd == ' ') {
        this.$router.push('/login')
      }

      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
        CAL_PRD: dateformat('yyyy', this.dateSearch),
        PASSWORD: this.pwd,
      }
      GetMyIncomeDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.salaryList = res.DATA
        }
      })
    },
  },
  components: {
    toptitle,
  },
  computed: {},
  filters: {
    datefmt(val) {
      //格式化日期查询条件的显示内容
      if (!val) return ''
      return dateformat('yyyy年', new Date(val))
    },
  },
  created() {
    this.pwd = this.$route.query.param
    //能选择的最大年份
    this.MaxDate = new Date(dateformat('yyyy-MM-01'))
    this.dateSearch = new Date(dateformat('yyyy-MM-01'))
  },
}
</script>

<style lang="less" scoped>
.menu {
  display: flex;
  border-top: 1px solid #e5e5e5;
  margin: 0px;
  padding: 0px;
  div {
    box-shadow: 0;
  }
  .choosedate {
    width: 50%;
    background: white;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #323233;
    font-size: 15px;
    overflow: hidden;
    .down-rowp {
      display: inline-block;
      content: '';
      position: relative;
      top: 2px;
      margin-left: 3px;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-top-color: #999;
    }
  }
}
section {
  margin: 10px 14px;
  background: white;
  color: #999;
  border-radius: 5px;
  font-size: 13px;
  line-height: 35px;
  padding: 0 15px;
  .income-top {
    display: flex;
    .detail {
      text-align: right;
      flex: 1;
      i {
        position: relative;
        top: 2px;
        left: 4px;
      }
    }
  }
  span {
    color: black;
    font-size: 15px;
    margin-left: 10px;
    font-weight: bold;
  }
}
/deep/ .van-dropdown-menu {
  display: flex;
  .van-dropdown-menu__bar {
    width: 50%;
    box-shadow: none;
  }
  .change {
    width: 50%;
    background: white;
    text-align: center;
    line-height: 48px;
    .icon-eyes {
      position: relative;
      top: 5px;
    }
  }
}

.icon-eyes {
  top: 4px;
}
</style>

